<template>
	<v-card>
		<v-card-title>
			<h2>Ocena dotychczasowej współpracy</h2>
		</v-card-title>

		<v-card-text>
			<v-layout row wrap align-center>
				<h2 class="ma-4 mr-5" style="text-align: center">Lata realizacji projektów:</h2>
				<v-flex xs1>
					<div class="mt-3 mr-2">
						<v-select
							aria-label="years filter"
							style="display: inline"
							v-model="filter.from"
							:items="years"
							label="Od"
							item-text="value"
							item-value="id"
							for="add-offer-popup-offer-number-modules"
							clearable
						></v-select>
					</div>
				</v-flex>
				<v-flex xs1>
					<div class="mt-3 ml-2">
						<v-select
							aria-label="years filter"
							style="display: inline"
							v-model="filter.to"
							:items="years"
							label="Do"
							item-text="value"
							item-value="id"
							for="add-offer-popup-offer-number-modules"
							id="add-offer-popup-offer-number-modules"
							clearable
						></v-select>
					</div>
				</v-flex>
				<v-btn @click="getBidderList" color="primary" dark class="ml-5">
					Sugeruj ocenę
				</v-btn>
				<v-btn @click="exportBidderList" color="primary" dark>
					Eksportuj
				</v-btn>
			</v-layout>
		</v-card-text>

		<v-data-table
			hide-actions
			:headers="headers"
			:items="collaborators"
			class="elevation-1">
			<template slot="items" slot-scope="props">
				<tr style="height: 70px;">
					<td>
						{{ props.item.bidderName }}
					</td>
					<td width="320px">
						{{ getEvaluation(props.item) }}
					</td>
					<td>
						{{ getSuggestedEvaluation(props.item) }}
					</td>
					<td>
						<v-icon
							v-if="isSecretary || isAdministrator"
							small class="mr-2"
							title="Edytuj ocenę komisji"
							@click="viewCommitteeCollaborationEvaluation(props.item.bidderId)">
							edit
						</v-icon>
						<v-icon
							v-else
							small class="mr-2"
							title="Podgląd oceny komisji"
							@click="viewCommitteeCollaborationReadOnlyEvaluation(props.item.bidderId)">
							description
						</v-icon>
						<v-icon
							small class="mr-2"
							title="Podgląd ocen oferenta"
							@click="viewBiddersEvaluationHistory(props.item.bidderId)">
							folder
						</v-icon>
					</td>
				</tr>
			</template>
		</v-data-table>
	</v-card>
</template>

<script>
	import {CollaborationEvaluation} from "@/api/generated/CollaborationEvaluation";
	import {ContestRealizationYear} from "@/api/generated/ContestRealizationYear";
	import {Files} from "@/utils/Files";
	import {Numbers} from "@/utils/Numbers";
	import {PublicContest} from "@/api/generated/PublicContest";
  import {Filters} from "@/utils/Filters";

	export default {
		name: "BiddersCollaborationEvaluation",

    mixins: [Filters],

		data() {
			return {
				isSecretary: false,
				isAdministrator: false,
				editedItem: {},
				collaborators: [],
				years: [],
				filter: {
					from: undefined,
					to: undefined
				},
				headers: [
					{text: "Nazwa organizacji", value: "bidderName", sortable: false},
					{text: "Ocena", value: "evaluation", sortable: false},
					{text: "Ocena sugerowana", value: "suggestedEvaluation", sortable: false},
					{text: "Akcje", value: "actions", sortable: false},
				],
			};
		},

		methods: {
			getEvaluation (item) {
				return (item.evaluation === null || item.evaluation < 0) ? '' : Numbers.methods.formatWithoutFixed(item.evaluation * 2);
			},

			getSuggestedEvaluation(item) {
				return item.suggestedEvaluation < 0 ? '-' : Numbers.methods.formatWithoutFixed(item.suggestedEvaluation);
			},

			refresh () {
				getUserStatus(this);
				getBidderList(this);
				getRealizationYears(this);
			},

			getBidderList () {
				getBidderList(this);
			},

			exportBidderList () {
				this.filter.from = this.filter.from === undefined ? -1 : this.filter.from;
				this.filter.to = this.filter.to === undefined ? -1 : this.filter.to;
				CollaborationEvaluation.postExportCollaborators(this, this.$route.params.id, this.filter.from, this.filter.to,
					successResponse => {
						let filename = "eksport_ocen.xlsx";
						Files.methods.downloadBlobResponse(successResponse, filename);
						this.$messagesBus.$emit("success", "Eksport danych wykonano do pliku " + filename, successResponse);
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Eksport nieudany", errorResponse);
					},
					{
						responseType: "blob",
					}
				);
			},

			viewCommitteeCollaborationEvaluation (bidderId) {
				this.$router.push("/app/contest/" + this.$route.params.id + "/collaboration-evaluation/" + bidderId);
			},

			viewCommitteeCollaborationReadOnlyEvaluation (bidderId) {
				this.$router.push("/view/contest/" + this.$route.params.id + "/collaboration-evaluation/" + bidderId);
			},

			viewBiddersEvaluationHistory (bidderId) {
				this.$router.push("/app/contest/" + this.$route.params.id + "/bidder-personal-evaluations/" + bidderId + "/history");
			}
		},

		created () {
			this.refresh();
      this.filter = this.retrieveFilters(this.filter);
		}
	};
	
	function getUserStatus (ctx) {
		PublicContest.getIsSecretary(ctx, ctx.$route.params.id, response => ctx.isSecretary = response);
		PublicContest.getIsContestAdministrator(ctx, ctx.$route.params.id, response => ctx.isAdministrator = response);
	}

	function getBidderList (ctx) {
		ctx.filter.from = ctx.filter.from === undefined ? -1 : ctx.filter.from;
		ctx.filter.to = ctx.filter.to === undefined ? -1 : ctx.filter.to;
		CollaborationEvaluation.getContestCollaborators(ctx,
			ctx.$route.params.id,
			ctx.filter.from,
			ctx.filter.to,
			successResponse => {
				ctx.collaborators = successResponse;
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się załadować listy oferentów", errorResponse);
			});
	}

	function getRealizationYears (ctx) {
		ContestRealizationYear.getList(ctx, successResponse => {
				ctx.years = successResponse.items;
				ctx.years.sort(function (x, y) {
					return y.value - x.value;
				});
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się załadować lata realizacji", errorResponse);
			});
	}

</script>

<style scoped>

</style>
